<template>
  <div>
    <Title :pages="[{ icon: 'circle', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access || update_access"
        :modal_title="modal_title"
        :button_name="create_access ? 'Crear ' + modal_title : ''"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-card-subtitle class="pt-5">
          Clasifican las líneas del extracto bancario (comisiones, impuestos, intereses) para registrarlas en Syscore con una plantilla de tesorería desde la conciliación.
        </v-card-subtitle>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{ itemsPerPage: 15 }"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.match_field_name }}</td>
              <td><code>{{ props.item.pattern }}</code></td>
              <td>{{ props.item.tesoreria_movement_template ? props.item.tesoreria_movement_template.name : "-" }}</td>
              <td>{{ props.item.money_account ? props.item.money_account.name : "Todas" }}</td>
              <td class="text-center px-0" style="min-width: 100px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)">edit</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)">delete</v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <span class="grey--text">No hay resultados para «{{ search }}»</span>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import { conciliacionReglaService } from "@/libs/ws/conciliacionReglaService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";

export default {
  components: { Title, Modal, DialogDelete },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      service: conciliacionReglaService,
      page_title: "Reglas de conciliación",
      modal_title: "Regla de conciliación",
      mainItem: {
        id: 0,
        match_field: "bank_code",
        pattern: "",
        tesoreria_movement_template: null,
        money_account: null,
        enabled: true,
      },
      defaultItem: null,
      headers: [
        { text: "Buscar en", align: "left", sortable: true, value: "match_field_name" },
        { text: "Texto", align: "left", sortable: true, value: "pattern" },
        { text: "Plantilla", align: "left", sortable: true, value: "tesoreria_movement_template.name" },
        { text: "Cuenta", align: "left", sortable: true, value: "money_account.name" },
        { text: "Acción", align: "center", value: "" },
      ],
      list: [],
      dialog_delete: false,
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
  },
  methods: {
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
    },
    getFilterParams() {
      return { enabled: "all" };
    },
  },
};
</script>
